import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {Calendar} from 'primeng/calendar';
import {LogLevel} from '../../logging/data/logLevel';
import {LogSourceType} from '../../logging/data/logSourceType';
import {LogSource} from '../../logging/data/logSource';
import {LoggerService} from '../../logging/services/logger.service';

@Component({
  selector: 'w-date-field-interval',
  templateUrl: './date-field-interval.component.html',
  styleUrls: ['./date-field-interval.component.scss']
})
export class DateFieldIntervalComponent implements OnInit, OnChanges {

  @ViewChild('min', { static: false }) min: Calendar;
  @ViewChild('max', { static: false }) max: Calendar;

  @Input() start: Date;
  @Input() end: Date;
  @Input() labelStart: string;
  @Input() labelEnd: string;
  @Input() hideLabel: boolean = false;
  @Input() disabled: boolean = false;

  @Output() valueChange: EventEmitter<{start: Date, end: Date}> = new EventEmitter<{start: Date, end: Date}>();
  @Output() startChange: EventEmitter<Date> = new EventEmitter<Date>();
  @Output() endChange: EventEmitter<Date> = new EventEmitter<Date>();

  today: Date = new Date();
  commonOptions: { title: string, startDate: Date, endDate: Date }[] = [];
  stringValueStart: string;
  stringValueEnd: string;

  constructor(private loggingService: LoggerService) { }

  ngOnInit(): void {
    this.commonOptions = [
      { title: 'Today', startDate: new Date(new Date().setHours(0, 0, 0, 0)), endDate: new Date(new Date().setHours(23, 59, 59, 999)) },
      { title: 'Yesterday', startDate: new Date(new Date(new Date().setDate(new Date().getDate() - 1)).setHours(0, 0, 0, 0)), endDate: new Date(new Date(new Date().setDate(new Date().getDate() - 1)).setHours(23, 59, 59, 999)) },
      { title: 'This week', startDate: new Date(new Date(new Date().setHours(0, 0, 0, 0)).setDate(new Date().getDate() - new Date().getDay())), endDate: new Date(new Date().setHours(23, 59, 59, 999)) },
      { title: 'Last 7 days', startDate: new Date(new Date(new Date().setDate(new Date().getDate() - 6)).setHours(0, 0, 0, 0)), endDate: new Date(new Date().setHours(23, 59, 59, 999)) },
      { title: 'This month', startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1), endDate: new Date(new Date().setHours(23, 59, 59, 999)) },
      { title: 'Last 30 days', startDate: new Date(new Date(new Date().setDate(new Date().getDate() - 29)).setHours(0, 0, 0, 0)), endDate: new Date(new Date().setHours(23, 59, 59, 999)) },
      { title: 'Last 6 months', startDate: new Date(new Date().getFullYear(), new Date().getMonth() - 5, 1), endDate: new Date(new Date().setHours(23, 59, 59, 999)) },
      { title: 'All time', startDate: null, endDate: null }
    ];
  }

// '08/31/2024'

  ngOnChanges(changes: SimpleChanges) {
    if (changes.value && changes.value.currentValue){
      this.start = changes.value.currentValue;
      if (this.start) {
        this.stringValueStart = this.start.toLocaleDateString();
      }
    }
  }


  dateHandler() {
    const inputMin = this.min.el.nativeElement;
    const inputMax = this.max.el.nativeElement;
    const actualInputMin = inputMin.getElementsByTagName('input')[0];
    const actualInputMax = inputMax.getElementsByTagName('input')[0];

    this.stringValueStart = this.dateProcessor(this.start, actualInputMin);
    this.stringValueEnd = this.dateProcessor(this.end, actualInputMax);

    const regexDateExp = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;

    if (regexDateExp.test(this.stringValueStart) || regexDateExp.test(this.stringValueEnd) || (this.stringValueStart === null || this.stringValueEnd === null)) {
      if (this.stringValueStart === null) {
        this.start = null;
      }
      if (this.stringValueEnd === null) {
        this.end = null;
      }
      if (this.stringValueStart) {
        this.start = new Date(this.stringValueStart);
      }
      if (this.stringValueEnd){
        this.end = new Date(new Date(this.stringValueEnd).getTime() + (86399 * 1000));
      }

      this.valueChange.emit({start: this.start, end: this.end});
    } else {
      return;
    }
  }

  dateProcessor(date: Date, actualInput: any): string{

    let stringValue: string;

    if (!date && (!actualInput.value || actualInput.value.length === 0)) {
      return null;
    }

    if (!stringValue) {
      stringValue = actualInput.value;
    } else {
      // primeng calendar parsed the date successfully
      return;
    }

    const split = stringValue.split('/');
    const howManyValues = split.length;

    // if (!this.stringValue) {
    //   this.stringValue = new Date().getMonth() + 1 + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    // }

    switch (howManyValues) {


      case 1:

        // x
        if (split[0].length === 1) {
          const month = new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
          stringValue = month + '/' + '0' + split[0] + '/' + new Date().getFullYear();
        }
        if (split[0].length === 2) {
          const month = new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
          stringValue = month + '/' + '0' + split[0] + '/' + new Date().getFullYear();
        }
        break;

      case 2:

        // x/x
        if (split[0].length === 1 && split[1].length === 1) {
          split[0] = '0' + split[0];
          split[1] = '0' + split[1];
          stringValue = split[0] + '/' + split[1] + '/' + new Date().getFullYear();
        } else {
          stringValue = split[0] + '/' + split[1] + '/' + new Date().getFullYear();
        }
        break;

      case 3:

        // x/xx/xxxx
        if (split[0].length === 1 && split[1].length === 2 && split[2].length === 4) {
          split[0] = '0' + split[0];
          stringValue = split[0] + '/' + split[1] + '/' + split[2];
        }

        // x/x/xx
        if (split[0].length === 1 && split[1].length === 1 && split[2].length === 2) {
          split[0] = '0' + split[0];
          split[1] = '0' + split[1];
          const yearSubstr = new Date().getFullYear().toString().substr(0, 2);
          stringValue = split[0] + '/' + split[1] + '/' + yearSubstr + split[2];
        }

        // x/xx/xx
        if (split[0].length === 1 && split[1].length === 2 && split[2].length === 2) {
          split[0] = '0' + split[0];
          const yearSubstr = new Date().getFullYear().toString().substr(0, 2);
          stringValue = split[0] + '/' + split[1] + '/' + yearSubstr + split[2];
        }

        // xx/x/xxxx
        if (split[0].length === 2 && split[1].length === 1 && split[2].length === 4) {
          split[1] = '0' + split[1];
          stringValue = split[0] + '/' + split[1] + '/' + split[2];
        }
    }
    return stringValue;
  }


  calendarFocus() {
    // at the time of writing this, there was a bug with primeng calendar, which required two tab presses
    // for tabbing into the date input, so I had to manually select the input inside the component for tabbing with this event

    const input = this.min.el.nativeElement;
    const actualInput = input.getElementsByTagName('input')[0];

    actualInput.focus();
    actualInput.select();
  }

  // dateSelect($event: any) {
  //   this.start = $event;
  //   this.valueChange.emit({start: this.start, end: this.end});
  // }

  startDateSelect($event: any){
    this.start = $event;
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.DateIntervalFieldComponent, 'Inserted start date: ' + this.start);
    this.valueChange.emit({start: this.start, end: this.end});
  }

  endDateSelect($event: any) {
    this.end = new Date(new Date($event).getTime() + (86399 * 1000));
    this.valueChange.emit({start: this.start, end: this.end});
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.DateIntervalFieldComponent, 'Inserted end date: ' + this.end);
  }

  onOptionClick(i: number, calendar: Calendar) {
    this.start = this.commonOptions[i].startDate;
    this.end = this.commonOptions[i].endDate;
    this.valueChange.emit({start: this.start, end: this.end});
    calendar.toggle();
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.DateIntervalFieldComponent, 'Selected interval: ' + this.start + ' ' + this.end);

  }

  setMaxBetweenDate() {
    if ( this.end < this.start ){
      this.start = this.end;
    }
  }

}
